export default "__VITE_ASSET__fxloEyvd__"